import { render, staticRenderFns } from "./TabLogAcesso.vue?vue&type=template&id=7cae64cc"
import script from "./TabLogAcesso.vue?vue&type=script&lang=ts"
export * from "./TabLogAcesso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports